<template>
  <div class="elite-content_sidebar_level1_menu_wrapper">
    <ul>
      <li>
        <router-link
          :to="{ name: 'Dashboard' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
            :title="$t('APPS.DASHBOARD')"
          >
            <span class="icon">
              <i class="fa-regular fa-gauge"></i>
            </span>
            <span class="text">
              {{ $t("APPS.DASHBOARD") }}
            </span>
          </a>
        </router-link>
      </li>
      <li v-if="false">
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_RESELLER)"
          :to="{ name: 'Reseller Page' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
            :title="$t('APPS.RESELLER_MODULE')"
          >
            <span class="icon">
              <img src="/img/sm-reseller.svg" alt="icon" />
            </span>
            <span class="text">
              {{ $t("APPS.RESELLER_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <reseller-module-menu></reseller-module-menu>
            </span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_ADMIN)"
          :to="{ name: 'Admin Page' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
            :title="$t('APPS.ADMIN_MODULE')"
          >
            <span class="icon">
              <img src="/img/sm-settings.svg" alt="icon" />
            </span>
            <span class="text">
              {{ $t("APPS.ADMIN_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <admin-module-menu></admin-module-menu>
            </span>
          </a>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import AdminModuleMenu from "../../../Pages/AdminModule/AdminModuleMenu.vue";
import CrmModuleMenu from "../../../Pages/CrmModule/CrmModuleMenu.vue";
import FilesExplorerModuleMenu from "../../../Pages/FilesExplorerModule/FilesExplorerModuleMenu.vue";
import InventoryModuleMenu from "../../../Pages/InventoryModule/InventoryModuleMenu.vue";
import PurchasesModuleMenu from "../../../Pages/PurchasesModule/PurchasesModuleMenu.vue";
import ResellerModuleMenu from "../../../Pages/ResellerModule/ResellerModuleMenu.vue";
import SalesModuleMenu from "../../../Pages/SalesModule/SalesModuleMenu.vue";
import InspectproModuleMenu from "../../../Pages/InspectproModule/InspectproModuleMenu.vue";
import VehiclesModuleMenu from "../../../Pages/VehiclesModule/VehiclesModuleMenu.vue";

export default {
  components: {
    AdminModuleMenu,
    ResellerModuleMenu,
    FilesExplorerModuleMenu,
    InventoryModuleMenu,
    SalesModuleMenu,
    PurchasesModuleMenu,
    CrmModuleMenu,
    InspectproModuleMenu,
    VehiclesModuleMenu,
  },

  props: {},

  async created() {},

  computed: {},

  data() {
    return {};
  },

  methods: {},
};
</script>
